import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Snackbar } from "@material-ui/core";

import AlertContent from "components/AlertContent";

import { unsetFetchMessage } from "store/helper/actions";

const MessageService = () => {
  const dispatch = useDispatch();

  const { messagePayload } = useSelector(({ helperReducer }) => helperReducer);

  const handleClose = () => {
    dispatch(unsetFetchMessage());
  };

  const computedSeverity = (() => {
    try {
      const msg = messagePayload && messagePayload.message;
      if (typeof msg === 'string' && /unauthorized/i.test(msg)) return 'error';
    } catch (e) {}
    return messagePayload && messagePayload.severity;
  })();

  const shouldShow = (() => {
    try {
      const msg = messagePayload && messagePayload.message;
      if (typeof msg === 'string' && /unauthorized/i.test(msg)) return false;
    } catch (e) {}
    return !!messagePayload;
  })();

  return (
    <Snackbar
      open={shouldShow}
      autoHideDuration={3000}
      onClose={handleClose}
    >
      {messagePayload && (
        <AlertContent
          severity={computedSeverity}
          variant={"filled"}
        >
          {messagePayload.message}
        </AlertContent>
      )}
    </Snackbar>
  );
};

MessageService.propTypes = {};

export default MessageService;
